export default {"src":"/_next/static/media/all-board.9ed6dfb3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};